import { Primary } from '@cinch-labs/design-system'
import { StoryEvCtaButton } from '../../types/electric-cars-page'
import {
  StoryblokImage,
  getStoryblokImageServiceUrl,
} from '@cinch-nx/data-storyblok'
import styles from './ev-pre-footer.module.css'

interface EvPreFooterProps {
  evCta: StoryEvCtaButton[]
  image: StoryblokImage
}

const handleClick = (url: string) => {
  window.open(url, '_blank')
}

export const EvPreFooter = ({ evCta, image }: EvPreFooterProps) => {
  const { label, url } = evCta[0]
  const { filename, alt } = image
  const sbImageUrl = getStoryblokImageServiceUrl(filename, {
    filters: [{ quality: 80 }],
  })

  return (
    <section className={styles.container}>
      <Primary
        type="submit"
        data-testid="ev-button"
        onClick={() => handleClick(url)}
      >
        {label}
      </Primary>
      <div>
        <img
          className={styles.preFooterImage}
          src={sbImageUrl}
          alt={alt ? alt : 'pre footer image'}
        />
      </div>
    </section>
  )
}
